import { Component, Input, inject } from '@angular/core';
import {VwuiModalService} from '@bvgo-ict/vwui-angular';
import {BehaviorSubject, Observable} from 'rxjs';
import {Mode} from '../../../models/mode';
import {switchMap} from 'rxjs/operators';
import {LinkService} from '../../../services/link.service';
import {LinkModalComponent} from '../link-modal/link-modal.component';
import {Link} from '../../../models/link';

@Component({
    selector: 'app-prd-links',
    templateUrl: './prd-links.component.html',
    standalone: false
})
export class PrdLinksComponent {
    private linkService = inject<LinkService>('LinkService' as any);
    private vwuiModalService = inject(VwuiModalService);

    @Input() refId = 0;
    @Input() mode$: Observable<Mode> | undefined;

    refresh$ = new BehaviorSubject<null>(null);
    links$ = this.refresh$.pipe(
        switchMap(() => {
            return this.linkService.list(this.refId);
        })
    );

    private modalOpen = false;

    openModal(event?: Event, link?: Link): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (this.modalOpen) {
            return;
        }

        this.modalOpen = true;
        this.vwuiModalService.open(LinkModalComponent, {
            closeOnBackdropClick: false,
            data: {refId: this.refId, link}
        }).afterClosed.subscribe(_ => {
            this.modalOpen = false;
            this.refresh$.next(null);
        });
    }

    async deleteMember(event: Event, link: Link): Promise<void> {
        event.preventDefault();
        event.stopPropagation();

        if (!window.confirm('Weet u zeker dat u dit document wilt verwijderen?')) {
            return;
        }

        await this.linkService.delete(this.refId, link).toPromise();
        this.refresh$.next(null);
    }
}
